// Actions
import { loginSuccess } from './authActions';

// Components
import createAuthTokenSuccessRedirect from './createAuthTokenSuccessRedirect';

export default createAuthTokenSuccessRedirect(loginSuccess);
